import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import VenueManagementLayer from "../components/VenueManagementLayer";

const VenueManagementPage = () => {
    return (
        <MasterLayout>
            <Breadcrumb title="My Venues" />
            <VenueManagementLayer />
        </MasterLayout>
    );
};

export default VenueManagementPage;
